module.exports = __webpack_public_path__ + "img/Skirt-Front-B1-Da-Fc-Ge-Hc-Ia.d724064c.png";